
















































import { Component, Vue } from 'vue-property-decorator';
import { Repository } from '@/@types/LibraryComponent';
import RepositoryCard from './RepositoryCard.vue';
import GitHistoryList from './GitHistoryList.vue';
import CreateRepositoryModal from './CreateRepositoryModal.vue';
import { vxm } from '@/store';
import { GetLogsQueryDto } from '@/@types/theoryGit/logs';
import { CreateBranchDto } from '@/@types/theoryGit/branches';
import { CreateRepositoryInfoDto, FindRepositoriesDetail } from '@/@types/theoryGit/repositoryInfo';

@Component({
  components: {
    CreateRepositoryModal,
    RepositoryCard,
    GitHistoryList,
  },
})
export default class RepositoryList extends Vue {
  private repositories: FindRepositoriesDetail[] = [];
  private projectKey: string = 'project-1';
  private isOpenCreateRepositoryModal = false;

  private async created() {
    await vxm.theoryGit.repositoryInfoStore.fetchRepositories(this.projectId);
    this.repositories.push(...this.getRepositories);
  }

  private openCreateRepositoryModal() {
    this.isOpenCreateRepositoryModal = true;
  }

  private closeCreateRepositoryModal() {
    this.isOpenCreateRepositoryModal = false;
  }

  private async createRepository(params: CreateRepositoryInfoDto) {
    await vxm.theoryGit.repositoryInfoStore.createRepository(params);
    await vxm.theoryGit.repositoryInfoStore.fetchRepositories(this.projectId);
    this.repositories.splice(0);
    this.repositories.push(...this.getRepositories);
    this.closeCreateRepositoryModal();
  }

  private async createBranch() {
    const createBranchDto: CreateBranchDto = {
      newRef: 'develop',
      ref: 'main',
      projectId: this.projectId,
    };
    await vxm.theoryGit.branchesStore.createBranch({ repositoryInfoId: 28, createBranchDto });
  }

  private get projectId() {
    return vxm.theoryApi.authStore.getCurrentProjectId ?? 0;
  }

  private get getRepositories() {
    return vxm.theoryGit.repositoryInfoStore.getRepositories?.results ?? [];
  }

  private get commitLogs() {
    return vxm.theoryGit.logsStore.getCommitLogs?.results ?? [];
  }
}
